// extracted by mini-css-extract-plugin
module.exports = {"withFullscreen":"Fullscreen_withFullscreen__3jRHk","fullscreen":"Fullscreen_fullscreen__1fLXL"};